var FakeTourTemplateBuilder = function() {};

FakeTourTemplateBuilder.prototype = {
  beforeRender: function() {},
  render: function() {
    return '';
  },
  afterRender: function() {}
};

module.exports = FakeTourTemplateBuilder;



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/new-feature-tour/fake-tour-template-builder.js
// module id = 1053
// module chunks = 0